import React, { useState } from "react";
import I18n from 'i18n.js.erb'
import SubmissionListWithdrawalUnavailableModal from "./SubmissionListWithdrawalUnavailableModal";


const WithdrawalCase = ({ question, answer }) => {

  return <div className="slx-withdrawal__case">
    <img src={window.location.origin + '/images/icons/confirmation.svg'} alt="" />
    <p className="slx-withdrawal__paragraph">
      <b className="text-weight-500">{question}</b> {answer}
    </p>
  </div>
}


const SubmissionListWithdrawalCard = ({ submissionList }) => {

  const [showUnavailableModal, setShowUnavailableModal] = useState(false);

  const available = submissionList.refundable === true;
  const termsUrl = `/${I18n.locale}/grading_service_terms_of_use.html#withdrawal`;
  const supportUrl = `/${I18n.locale}/support.html`;

  return (
    <div className="slx-withdrawal slx-section">
      <div className="slx-withdrawal__icon">
        <img src={window.location.origin + '/images/icons/return_icon.svg'} alt="" />
      </div>

      <div className="slx-withdrawal__body">
        {/* Blocco superiore del Figma: testo, casistiche e rimando al supporto */}
        <div className="slx-withdrawal__content">
          <div className="slx-withdrawal__text">
            <h4 className="slx-withdrawal__title">
              {I18n.t('js.editSubmissionListPage.withdrawal.title')}
            </h4>

            <p className="slx-withdrawal__paragraph">
              {I18n.t('js.editSubmissionListPage.withdrawal.intro')}
              &nbsp;
              <a href={termsUrl} target="_blank" className="slx-link">
                {I18n.t('js.editSubmissionListPage.withdrawal.introLink')}
              </a>.
            </p>

            <div className="slx-withdrawal__cases">
              <WithdrawalCase
                question={I18n.t('js.editSubmissionListPage.withdrawal.notShippedQuestion')}
                answer={I18n.t('js.editSubmissionListPage.withdrawal.notShippedAnswer')}
              />
              <WithdrawalCase
                question={I18n.t('js.editSubmissionListPage.withdrawal.receivedQuestion')}
                answer={I18n.t('js.editSubmissionListPage.withdrawal.receivedAnswer')}
              />
              <WithdrawalCase
                question={I18n.t('js.editSubmissionListPage.withdrawal.gradedQuestion')}
                answer={I18n.t('js.editSubmissionListPage.withdrawal.gradedAnswer')}
              />
            </div>
          </div>

          <p className="slx-withdrawal__paragraph">
            {I18n.t('js.editSubmissionListPage.withdrawal.moreInfo')}
            &nbsp;
            <a href={supportUrl} target="_blank" className="slx-link">
              {I18n.t('js.editSubmissionListPage.withdrawal.moreInfoLink')}
            </a>
          </p>
        </div>

        {/* Blocco inferiore del Figma: solo la call to action, allineata a destra.
            Il pulsante resta sempre cliccabile: se il recesso non è disponibile apre la modale con il motivo */}
        <div className="slx-withdrawal__footer">
          {
            available ?
              <a href={`/submission_lists/${submissionList.id}/withdrawal`} className="slx-pill">
                {I18n.t('js.editSubmissionListPage.withdrawal.openForm')}
              </a>
            :
              <button type="button" className="slx-pill" onClick={() => setShowUnavailableModal(true)}>
                {I18n.t('js.editSubmissionListPage.withdrawal.openForm')}
              </button>
          }
        </div>
      </div>

      <SubmissionListWithdrawalUnavailableModal
        show={showUnavailableModal}
        reason={submissionList.withdrawal_unavailability_reason}
        onClose={() => setShowUnavailableModal(false)}
      />
    </div>
  );
};

export default SubmissionListWithdrawalCard;
